// Formatos para Estadísticas 2.
//
// La plata NO se formatea acá: se reusa `utils/formatCurrency`, que ya conoce el
// símbolo y el país del cliente. Duplicarlo significaría que dentro de la misma
// pantalla dos números salgan distintos.

import { formatCurrency } from "../../utils/formatCurrency";

export { formatCurrency };

/**
 * Duración en horas, dicha como la diría una persona.
 *
 * "1,6 h" no significa nada para el dueño de un estacionamiento: nadie piensa en
 * décimas de hora. "1 h 36 min" sí. Por debajo de la hora se dicen sólo los
 * minutos, porque "0 h 40 min" es una forma rebuscada de decir "40 minutos".
 */
export function horas(h) {
  const n = Number(h) || 0;
  if (n <= 0) return "—";
  const totalMin = Math.round(n * 60);
  if (totalMin < 60) return `${totalMin} min`;
  const hh = Math.floor(totalMin / 60);
  const mm = totalMin % 60;
  return mm === 0 ? `${hh} h` : `${hh} h ${mm} min`;
}

/** "14:00". La hora del día, sin adornos. */
export function hora(h) {
  const n = Number(h);
  if (!Number.isFinite(n) || n < 0 || n > 23) return "—";
  return `${String(n).padStart(2, "0")}:00`;
}

/**
 * Fecha en dd/mm/aaaa, que es el formato del proyecto en los 12 países.
 * Acepta "2026-08-25" o un Date.
 */
export function fecha(v) {
  if (!v) return "—";
  const d = v instanceof Date ? v : new Date(String(v).length === 10 ? `${v}T00:00:00` : v);
  if (isNaN(d.getTime())) return String(v);
  const p = (x) => String(x).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
}

const DIAS = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
const MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio",
               "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

/** "martes 25 de agosto" — para cuando el día de la semana es parte del dato. */
export function fechaLarga(v) {
  if (!v) return "—";
  const d = v instanceof Date ? v : new Date(`${v}T00:00:00`);
  if (isNaN(d.getTime())) return String(v);
  return `${DIAS[d.getDay()]} ${d.getDate()} de ${MESES[d.getMonth()]}`;
}

/** "agosto 2026" a partir de "2026-08". */
export function mesLargo(ym) {
  if (!ym || String(ym).length < 7) return "—";
  const [a, m] = String(ym).split("-");
  const i = parseInt(m, 10) - 1;
  return i >= 0 && i < 12 ? `${MESES[i]} ${a}` : ym;
}

/**
 * Variación contra un valor previo.
 *
 * Devuelve `null` cuando no hay con qué comparar —y eso es distinto de cero—.
 * Un "0%" donde en realidad no había período anterior es una afirmación falsa:
 * dice "no cambió" cuando lo cierto es "no sé".
 */
export function variacion(actual, previo) {
  const a = Number(actual) || 0;
  const p = Number(previo);
  if (!Number.isFinite(p) || p === 0) return null;
  return ((a - p) / Math.abs(p)) * 100;
}

/** "+12%" / "−8%" / "—". El signo va siempre: sin él hay que adivinar. */
export function variacionTexto(v) {
  if (v === null || v === undefined || !Number.isFinite(v)) return "—";
  const r = Math.round(v);
  if (r === 0) return "sin cambios";
  return `${r > 0 ? "+" : "−"}${Math.abs(r)}%`;
}

/** Número entero con separador de miles, para conteos (no para plata). */
export function entero(n) {
  const v = Math.round(Number(n) || 0);
  return v.toLocaleString("es-AR");
}

/**
 * DÓNDE SE CARGA LA CAPACIDAD.
 *
 * Varios bloques quedan a medias sin este dato —el techo, el porcentaje de
 * ocupación, cuánto rinde cada cochera— y todos tienen que mandar al MISMO
 * lugar. Escrito una vez: si mañana cambia el menú de TicketControl, se corrige
 * acá y no en cinco pantallas.
 *
 * Y NUNCA se sugiere resincronizar para esto: la capacidad es configuración, no
 * un dato que viaje. Resincronizar no la trae, así que mandar a resincronizar
 * es hacerle perder el tiempo al cliente además de invitarlo a un trámite que
 * no le corresponde.
 */
export const RUTA_CAPACIDAD = "TicketControl → Configuración → General → Operación";
